import moment from "moment";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import MainDatatable from "../../../components/common/MainDatatable.jsx";
import { DeleteSvg, EditSvg, SwitchOffSvg, SwitchOnSvg } from "../../../assets/svg/index.js";
import { api_urls } from "../../../utils/api-urls/index.js";
import * as ReligiousActions from '../../../redux/actions/religiousAction';

const DailyDarshan = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { dailyDarshanData } = useSelector(state => state?.religiousReducer);

  //* DataTable Columns
  const columns = [
    { name: 'S.No.', selector: row => dailyDarshanData.indexOf(row) + 1, width: '80px' },
    { name: 'Title', selector: row => <div style={{ textTransform: 'capitalize' }}>{row?.title}</div> },
    { name: 'City', selector: row => <div style={{ textTransform: 'capitalize' }}>{row?.city}</div> },
    { name: 'Description', selector: row => <div style={{ textTransform: 'capitalize' }}>{row?.description}</div> },
    { name: 'Start Date Time', selector: row => moment(row?.startDateTime)?.format('DD-MMM-YYYY @ hh:mm a'), width: '180px' },
    { name: 'End Date Time', selector: row => moment(row?.endDateTime)?.format('DD-MMM-YYYY @ hh:mm a'), width: '180px' },
    { name: 'Thumbnail', cell: row => <img src={api_urls + row?.image} alt="thumbnail" style={{ width: '50px', height: '50px', borderRadius: '50%' }} />, width: '100px' },
    { name: 'Link', selector: row => <Link to={row?.link} target="_blank">Link</Link>, width: '80px' },
    // { name: 'Status', selector: row => <div style={{ cursor: "pointer" }}>{row?.status == 'Active' ? <SwitchOnSvg /> : <SwitchOffSvg />}</div> },
    {
      name: 'Action',
      cell: row => <div style={{ display: "flex", gap: "20px", alignItems: "center" }} >
        <div onClick={() => navigate('/religious/daily-darshan/edit-daily-darshan', { state: { stateData: row } })} style={{ cursor: "pointer" }}><EditSvg /></div>
        <div onClick={() => dispatch(ReligiousActions?.deleteDailyDarshan({ id: row?._id }))} style={{ cursor: "pointer" }}><DeleteSvg /></div>
      </div>,
      width: "120px"
    },
  ];

  useEffect(() => {
    //! Dispatching API for Getting Daily Darshan
    dispatch(ReligiousActions.getDailyDarshan());
  }, []);

  return (
    <>
      <MainDatatable data={dailyDarshanData} columns={columns} title={'Daily Darshan'} url={'/religious/daily-darshan/add-daily-darshan'} />

    </ >
  );
}

export default DailyDarshan;